var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 463.672 463.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3ba2f;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 231.836,
    cy: 231.836,
    r: 231.836
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.213,212.681l46.621-46.619,46.644,46.643,27.127-27.127L231.834,111.8l-73.747,73.75,27.126,27.127M111.8,231.832,138.932,204.7l27.126,27.127L138.93,258.958Zm73.409,19.159,46.621,46.619,46.643-46.642,27.141,27.113-.013.014-73.771,73.773L158.085,278.12l-.039-.038,27.167-27.091m112.4-19.144,27.128-27.128,27.126,27.126L324.74,258.973Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.349,231.822h.012L231.834,204.3l-20.343,20.343h0l-2.337,2.338-4.82,4.822-.039.037.039.039,27.5,27.5,27.527-27.527.013-.015-.025-.013"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.b1e0dfac9f621549538bd156c0dff62f.svg";
export { ForwardRef as ReactComponent };